export const baseTheme = {
  font: {
    size: {
      xxxxs: 10,
      xxxs: 12,
      xxs: 14,
      xs: 17,
      sm: 20,
      md: 24,
      lg: 32,
      xl: 36,
      xxl: 44,
      xxxl: 56,
      xxxxl: 72,
    },
    lineHeight: {
      xxxxs: 12,
      xxxs: 16,
      xxs: 20,
      xs: 24,
      sm: 28,
      md: 32,
      lg: 36,
      xl: 40,
      xxl: 44,
      xxxl: 56,
      xxxxl: 72,
    },
    letterSpacing: {
      none: 0,
      md: 0.7,
    },
    weight: {
      regular: 400,
      medium: 500,
      bold: 700,
      black: 900,
    },
  },
}
